import { PublicShell } from "@/components/PublicShell"
import { PublicMeta } from "@/components/public/PublicMeta"
import { StudioEditor } from "@/components/studio/StudioEditor"
import "@/styles/public-studio.css"

const TITLE = "Design Your Own Wine Label"
const DESCRIPTION =
  "Design a personalised wine label online: start from a template or bring your own artwork, set your wording and see it on a wine or MCC bottle."

// The label mock-up studio (M4; M5 adds "Describe your design"). SSR renders
// the header and the atelier's shell; the label canvas, the bottle preview and
// the bottle images mount on hydration (every browser API lives in effects and
// handlers).
export default function Studio() {
  return (
    <PublicShell>
      <PublicMeta title={TITLE} description={DESCRIPTION} />

      <section className="hero hero-compact studio-hero" aria-labelledby="studio-title">
        <div className="hero-glow" aria-hidden="true" />
        <div className="hero-inner">
          <div className="shell">
            <div className="hero-copy">
              <div className="eyebrow">The label studio</div>
              <h1 id="studio-title">Design your label</h1>
              <p className="lede">
                Start from a template and set your wording, fonts, colours, frame and logo, bring your own finished artwork, or describe it and we'll paint the artwork. Then see it on the bottle.
              </p>
              <div className="field-hint">Every mock-up is subject to graphic design approval by our team.</div>
            </div>
          </div>
        </div>
      </section>

      <section className="band band-charcoal studio-band" aria-label="Label studio">
        <div className="shell studio-shell">
          <StudioEditor />
        </div>
      </section>
    </PublicShell>
  )
}
